module.exports = __webpack_public_path__ + "static/media/bvn-validation.927235bb.svg";